import React from 'react';
import axios from 'axios'
import moment from 'moment';
import { toast, } from 'react-toastify';
import {NavLink} from "react-router-dom";
import Button from '@material-ui/core/Button';
import '../../assets/css/Order.css'
import CustomInput from '../../components/CustomInput/CustomInput';
import { withStyles } from '@material-ui/core/styles';
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputLabel from '@material-ui/core/InputLabel';
import RegularButton from "../../components/CustomButtons/Button.jsx";
import Datetime from "react-datetime";
import EventIcon from '@material-ui/icons/Event';
import { BASE_URL } from '../../utils/handleApi'

const useStyles = (theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            marginBottom: theme.spacing(5)
        }
    },
    rootButton: {
        '& > *': {
            margin: theme.spacing(1),
            marginTop: theme.spacing(-1.8),
            marginLeft: theme.spacing(1.5)
        }
    },
    paper: {
        backgroundColor: "red"
    },
    margin: {
        marginRight: theme.spacing(10)
    },
    withoutLabel: {
        marginTop: theme.spacing(2),
    },
    textField: {
        width: '16vw',
    },
});

class Detailstable extends React.Component {
    
    state = {
        borrowerNameState: "",
        borrowerBusinessNameState: "",
        coborrowerNameState: "",
        coborrowerBusinessNameState: "",
        instructionState: "",
        streetAddressState: "",
        cityState: "",
        stateState: "",
        zipState: "",
        orderRefState: "",
        orderNoState: "",
        orderDateState: "success",
        parcelState: "",
        lenderEmailState: "",
        lenderNameState: "",
        chooseProductState: "",
        products: [],
        productData: [],
        allProducts : [],
        
        borrowerName: "",
        borrowerBusinessName: "",
        coborrowerName: "",
        coborrowerBusinessName: "",
        instruction: "",
        streetAddress: "",
        city: "",
        state: "",
        zip: "",
        orderRef: "",
        orderNo: "",
        orderDueDate: moment().add(1, 'd').format("MM/DD/YYYY"),
        parcel: "",
        lenderEmail: "",
        lenderName: "",
        chooseProduct: "",
        multipleSelect: [""],
        
        required: "",
        requiredState: "",
        typeEmail: "",
        typeEmailState: "",
        number: "",
        numberState: "",
        url: "",
        urlState: "",
        equalTo: "",
        whichEqualTo: "",
        equalToState: "",
        
        minLength: "",
        minLengthState: "",
        maxLength: "",
        maxLengthState: "",
        range: "",
        rangeState: "",
        minValue: "",
        minValueState: "",
        maxValue: "",
        maxValueState: "",
        isValid : true,

        showNoProductMessage: false,
        isFormSubmitting: false
    }

    componentDidMount(){
      document.getElementById("zip").min = "0";
      axios.post(`${BASE_URL}/product/all`, {
        'lender_id': this.props.lenderId
      })
      .then(res => {
        if(!res.data.length){
          this.setState({ showNoProductMessage: true })
        }
        else{
          this.setState({
            allProducts : res.data,
            productData : res.data[0].inputs,
            products: res.data.map((product) => ({
              id: product.id,
              name: product.name
            }))
          })
          this.fetchOrderNo();
          this.fetchLenderNameEmail();
        }
      })
      .catch(() => {
        toast.error('Some error happened in fetching Products!')
      })
      const chooseProductLabel = document.getElementById("chooseProductLabel")
      chooseProductLabel.style.color = "#aaa";
    }

    componentDidUpdate(){
      const { chooseProductState } = this.state;
      const chooseProductLabel = document.getElementById("chooseProductLabel")
      if(chooseProductState === "error"){
        chooseProductLabel.style.color = "#f44336"
      } else if(chooseProductState === "success") {
        chooseProductLabel.style.color = "#4caf50"
      }
    }

    fetchOrderNo = () => {
      let tokenStr = localStorage.getItem('token')
      axios.post(`${BASE_URL}/order/newId`, {
        "type": "M",
        "lender_id": this.props.lenderId
      },{
        headers: {
          'Authorization': `Bearer ${tokenStr}`
        }
      })
      .then(res => {
        const { order_id, vendor_id } = res.data
        const { lenderClientNo } = this.props;
        this.setState({
          orderNo: `${vendor_id}-${lenderClientNo.padStart(3,0)}-${order_id.toString().padStart(5,0)}`,
          orderNoState: "success"
        })
      })
      .catch(() => {
        toast.error('Some error happened in fetching Order No. !')
      })
    }

    fetchLenderNameEmail = () => {
      let tokenStr = localStorage.getItem('token')
      axios.post(`${BASE_URL}/lender/one`, {
        'lender_id': this.props.lenderId
      },{
        headers:{
          "Authorization": `Bearer ${tokenStr}`
        }
      })
      .then(res => {
        this.setState({
          lenderEmail: res.data.billing_contact,
          lenderEmailState: 'success',
          lenderName: res.data.name,
          lenderNameState: 'success',
        })
      })
      .catch(() => {
        toast.error('Some error happened in fetching Requester Name & Email!')
      })
    }
  
    verifyEmail(value) {
      var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (emailRex.test(value)) {
        return true;
      }
      return false;
    }
  
    verifyLength(value, length) {
      if (value.length >= length) {
        return true;
      }
      return false;
    }
   
    compare(string1, string2) {
      if (string1 === string2) {
        return true;
      }
      return false;
    }

    verifyNumber(value) {
      var numberRex = new RegExp("^[0-9]+$");
      if (numberRex.test(value)) {
        return true;
      }
      return false;
    }
   
    verifyUrl(value) {
      try {
        new URL(value);
        return true;
      } catch (_) {
        return false;
      }
    }

    change(event, stateName, type, stateNameEqualTo, maxValue) {
      switch (type) {
        case "email":
          if (this.verifyEmail(event.target.value)) {
            this.setState({ [stateName + "State"]: "success" });
            this.setState({ [stateName]: event.target.value });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "password":
          if (this.verifyLength(event.target.value, 1)) {
            this.setState({ [stateName + "State"]: "success" });
            this.setState({ [stateName]: event.target.value });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "equalTo":
          if (this.compare(event.target.value, this.state[stateNameEqualTo])) {
            this.setState({ [stateName + "State"]: "success" });
            this.setState({ [stateName]: event.target.value });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "checkbox":
          if (event.target.checked) {
            this.setState({ [stateName + "State"]: "success" });
            this.setState({ [stateName]: event.target.value });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "number":
          if (this.verifyNumber(event.target.value)) {
            this.setState({ [stateName + "State"]: "success" });
            this.setState({ [stateName]: event.target.value });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "length":
          if (this.verifyLength((event.target.value).replace(/ /g,""), stateNameEqualTo)) {
            this.setState({ [stateName + "State"]: "success" });
            this.setState({ [stateName]: event.target.value });
          } 
          else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "max-length":
          if (!this.verifyLength(event.target.value, stateNameEqualTo + 1)) {
            this.setState({ [stateName + "State"]: "success" });
            this.setState({ [stateName]: event.target.value });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "url":
          if (this.verifyUrl(event.target.value)) {
            this.setState({ [stateName + "State"]: "success" });
            this.setState({ [stateName]: event.target.value });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "min-value":
          if (
            this.verifyNumber(event.target.value) &&
            event.target.value >= stateNameEqualTo
          ) {
            this.setState({ [stateName + "State"]: "success" });
            this.setState({ [stateName]: event.target.value });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "max-value":
          if (
            this.verifyNumber(event.target.value) &&
            event.target.value <= stateNameEqualTo
          ) {
            this.setState({ [stateName + "State"]: "success" });
            this.setState({ [stateName]: event.target.value });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        case "range":
          if (
            this.verifyNumber(event.target.value) &&
            event.target.value >= stateNameEqualTo &&
            event.target.value <= maxValue
          ) {
            this.setState({ [stateName + "State"]: "success" });
            this.setState({ [stateName]: event.target.value });
          } else {
            this.setState({ [stateName + "State"]: "error" });
          }
          break;
        default:
          break;
      }
      switch (type) {
        case "checkbox":
          this.setState({ [stateName]: event.target.checked });
          break;
        default:
          this.setState({ [stateName]: event.target.value });
          break;
      }
    }

    handleMultiple = event => {
      this.setState({ 
        chooseProduct: event.target.value, 
        chooseProductState: "success", 
       });
    };
    
    addOrder = () => {
      let isValid = true
      const { borrowerName, borrowerBusinessName, instruction, streetAddress,
        city, state, zip, orderRef, parcel, chooseProduct, orderNo, orderDueDate, lenderName, lenderEmail, coborrowerName,
        coborrowerBusinessName, productData } = this.state;
      if (borrowerName.trim() === "") {
        if (borrowerBusinessName.trim() === ""){
          this.setState({ borrowerNameState: "error", borrowerBusinessNameState: "error" });
          isValid = false;
        } else if(borrowerBusinessName.trim() !== "") {
          this.setState({ borrowerNameState: "success", borrowerBusinessNameState: "success" })
          isValid = true;
        }
      } else if(borrowerBusinessName.trim() === ""){
        if (borrowerName.trim() === ""){
          this.setState({ borrowerNameState: "error", borrowerBusinessNameState: "error" });
          isValid = false;
        } else if(borrowerName.trim() !== "") {
          this.setState({ borrowerNameState: "success", borrowerBusinessNameState: "success" })
          isValid = true;
        }
      }
      if (instruction.trim() === "") {
        this.setState({ instructionState: "error" });
        isValid = false
      }
      if (streetAddress.trim() === "") {
        this.setState({ streetAddressState: "error" });
        isValid = false
      }
      if (city.trim() === "") {
        this.setState({ cityState: "error" });
        isValid = false
      }
      if (state.trim() === "") {
        this.setState({ stateState: "error" });
        isValid = false
      } 
      if (zip.trim() === "") {
        this.setState({ zipState: "error" });
        isValid = false
      }
      if (orderRef.trim() === "") {
        this.setState({ orderRefState: "error" });
        isValid = false
      }
      if (parcel.trim() === "") {
        this.setState({ parcelState: "error" });
        isValid = false
      }
      if(chooseProduct === ""){
        this.setState({ chooseProductState: "error" });
        isValid = false
      }

      if(isValid){
        this.setState({ isFormSubmitting: true })
        const orderData = {
          "lender_id": this.props.lenderId,
          "order_ref": orderRef,
          "order_no": orderNo,
          "order_date": moment().format('MM/DD/YYYY'),
          "due_date": orderDueDate ? moment(orderDueDate).format('MM/DD/YYYY') : moment().add(1, 'd').format('MM/DD/YYYY'),
          "requester_name": lenderName,
          "requester_email_address": lenderEmail,
          "instructions": instruction,
          "location":{
            "street_address": streetAddress,
            "city": city,
            "state": state,
            "zip": zip,
          },
          "parcel":parcel,
          "borrower": {
              "type":"I",
              "name":borrowerName,
              "business_name":borrowerBusinessName
          },
          "co_borrower": {
              "type":"I",
              "name":coborrowerName,
              "business_name":coborrowerBusinessName
            },
          "search_products_type": chooseProduct,
          "order_response": productData,
          "credential_id": localStorage.getItem('vendor_credential_id')
        }

        axios.post(`${BASE_URL}/order/add`, orderData)
        .then(() => {
          toast.success('Order Created Successfully!', {
            onClose: () => this.props.navigateBack()
          })
        })
        .catch(() => {
          toast.error('Some error happened!', {
            onClose: () => this.setState({ isFormSubmitting: false })
          })
        })
      }
    }

    disableHyphen = (e) => {
      if(e.keyCode === 189){
          e.preventDefault();
      }
    }
    
    render() {
        const { classes } = this.props
        const { orderNoState, orderDateState, borrowerBusinessNameState, borrowerNameState, instructionState, streetAddressState, cityState, stateState, zipState, orderRefState, parcelState, coborrowerBusinessNameState,coborrowerNameState, lenderEmailState, lenderNameState, orderNo, orderDueDate, lenderEmail, lenderName, chooseProduct, products, isFormSubmitting, showNoProductMessage } = this.state;
        let formControlClasses = classes.formControl;
        return (
            <div>
                <GridContainer className="form-container" style={{ width: '60vw', margin: '0 auto', backgroundColor: 'white' }}>
                    <GridItem xs={12}>
                        <Card>
                        <div className={classes.rootButton}>
                            <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', color: 'white', height: '50px', width: '170px', fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none' }} disabled>
                                Add Order
                            </Button>
                            <NavLink to={{
                              pathname: `/MyLenders/orders/${this.props.lenderId}`,
                              state: {
                                lender_name: this.props.lenderName, 
                                lender_clientNo: this.props.lenderClientNo}
                            }}>
                              <div className={classes.rootButton} style={{float: "right"}}>
                                <Button 
                                  variant="contained" 
                                  style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', 
                                    color: 'white', height: '50px', width: '120px', fontFamily: 'Roboto-Bold', 
                                    backgroundColor: '#04AB23', textTransform: 'none', textAlign: 'center', marginBottom: '10px' }} 
                                >
                                  Back
                                </Button>
                              </div>
                      </NavLink>
                      </div>
                        <CardBody>
                        <form>
                        <CustomInput
                           success={orderNoState === "success"}
                           error={orderNoState === "error"}
                          labelText="Order No"
                          id="orderNo"
                          formControlProps={{
                            fullWidth: true,
                            style: {borderBottom: '1px solid #04ab23'}
                          }}
                          inputProps={{
                            onChange: event =>
                              this.change(event, "orderNo", "length", 1),
                            type: "text",
                            value: orderNo,
                            readOnly: true,
                            disabled: true
                          }}
                        />
                          <CustomInput
                          success={orderDateState === "success"}
                          error={orderDateState === "error"}
                          labelText="Order Date"
                          id="orderDate"
                          formControlProps={{
                            fullWidth: true,
                            style: {borderBottom: '1px solid #04ab23'}
                          }}
                          inputProps={{
                            onChange: event =>
                              this.change(event, "orderDate", "length", 1),
                            type: "text",
                            value: moment().format('MM/DD/YYYY'),
                            readOnly: true,
                            disabled: true
                          }}
                        />
                        <label className="custom-date-picker-block">
                          <InputLabel className="custom-date-picker-label">
                            Order Due Date
                          </InputLabel>
                          <FormControl fullWidth>
                            <Datetime
                              id="orderDueDate"
                              className="custom-date-picker"
                              closeOnSelect
                              timeFormat={false}
                              value={orderDueDate}
                              onChange={event => {
                                return this.setState({ orderDueDate: event.format('MM/DD/YYYY')})
                              }}
                              isValidDate={currDate => currDate.isAfter(moment())}
                            />
                          </FormControl>
                          <div className="date-picker-icon">
                            <EventIcon />
                          </div>
                        </label>
                          {/* <CustomInput
                          success={orderDueDateState === "success"}
                          error={orderDueDateState === "error"}
                          labelText="Order Due Date"
                          id="orderDueDate"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: event =>
                              this.setState({ orderDueDate: event.target.value}),
                            type: "date",
                            value: orderDueDate || moment().format('MM/DD/YYYY'),
                          }}
                        /> */}
                          <CustomInput
                          success={borrowerBusinessNameState === "success"}
                          error={borrowerBusinessNameState === "error"}
                          labelText="Borrower Business Name"
                          id="borrowerBusinessName"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: event =>
                              this.change(event, "borrowerBusinessName", "length", 0),
                            type: "text"
                          }}
                        />
                        <CustomInput
                          success={borrowerNameState === "success"}
                          error={borrowerNameState === "error"}
                          labelText="Borrower Name"
                          id="borrowerName"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: event =>
                              this.change(event, "borrowerName", "length", 0),
                            type: "text"
                          }}
                        />
                          <CustomInput
                          success={instructionState === "success"}
                          error={instructionState === "error"}
                          labelText="Instruction"
                          id="instruction"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: event =>
                              this.change(event, "instruction", "length", 1),
                            type: "text"
                          }}
                        />
                          <CustomInput
                          success={streetAddressState === "success"}
                          error={streetAddressState === "error"}
                          labelText="Street Address"
                          id="streetAddress"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: event =>
                              this.change(event, "streetAddress", "length", 1),
                            type: "text"
                          }}
                        />
                          <CustomInput
                          success={cityState === "success"}
                          error={cityState === "error"}
                          labelText="City"
                          id="city"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: event =>
                              this.change(event, "city", "length", 1),
                            type: "text"
                          }}
                        />
                        <CustomInput
                          success={stateState === "success"}
                          error={stateState === "error"}
                          labelText="State"
                          id="state"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: event =>
                              this.change(event, "state", "length", 1),
                            type: "text"
                          }}
                        />
                        <CustomInput
                          success={zipState === "success"}
                          error={zipState === "error"}
                          labelText="ZIP"
                          id="zip"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: event =>
                              this.change(event, "zip", "length", 1),
                            type: "number",
                            onKeyDown: (e) => this.disableHyphen(e)
                          }}
                        />
                        <CustomInput
                          success={orderRefState === "success"}
                          error={orderRefState === "error"}
                          labelText="Order Reference"
                          id="orderRef"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: event =>
                              this.change(event, "orderRef", "length", 1),
                            type: "text"
                          }}
                        />
                        <CustomInput
                          success={parcelState === "success"}
                          error={parcelState === "error"}
                          labelText="Parcel"
                          id="parcel"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: event =>
                              this.change(event, "parcel", "length", 1),
                            type: "text"
                          }}
                        />
                        <CustomInput
                          success={coborrowerBusinessNameState === "success"}
                          //error={coborrowerBusinessNameState === "error"}
                          labelText="Co-Borrower Business Name"
                          id="coborrowerBusinessName"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: event =>
                              this.change(event, "coborrowerBusinessName", "length", 0),
                            type: "text"
                          }}
                        />
                      <CustomInput
                          success={coborrowerNameState === "success"}
                          //error={coborrowerNameState === "error"}
                          labelText="Co-Borrower Name"
                          id="coborrowerName"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: event =>
                              this.change(event, "coborrowerName", "length", 0),
                            type: "text"
                          }}
                        />
                      <CustomInput
                          success={lenderEmailState === "success"}
                          error={lenderEmailState === "error"}
                          labelText="Requester Email Address"
                          id="lenderEmail"
                          formControlProps={{
                              fullWidth: true,
                              style: {borderBottom: '1px solid #04ab23'}
                          }}
                          inputProps={{
                              onChange: event =>
                              this.change(event, "lenderEmail", "email"),
                              type: "email",
                              value: lenderEmail,
                              readOnly: true,
                              disabled: true
                          }}
                        />
                        <CustomInput
                          success={lenderNameState === "success"}
                          error={lenderNameState === "error"}
                          labelText="Requester Name"
                          id="lenderName"
                          formControlProps={{
                              fullWidth: true,
                              style: {borderBottom: '1px solid #04ab23'}
                          }}
                          inputProps={{
                              onChange: event =>
                              this.change(event, "lenderName", "length", 1),
                              type: "text",
                              value: lenderName,
                              readOnly: true,
                              disabled: true
                          }}
                        />
                        <FormControl fullWidth className={formControlClasses} style={{marginTop: "1em"}}>
                          <InputLabel 
                            id="chooseProductLabel" 
                            style={{fontSize: "14px", color: "#04ab23"}}
                          >
                            Choose Product
                          </InputLabel>
                          <Select 
                            style={{ fontSize: "14px", color: "#495057", fontWeight: "400", }}
                            id="demo-customized-select"
                            value={chooseProduct}
                            onChange={this.handleMultiple}
                            MenuProps={{ className: classes.selectMenu }}
                            inputProps={{
                              name: "multipleSelect",
                              id: "multiple-select"
                            }}
                          >
                            <MenuItem 
                              disabled
                              value=""
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelectedMultiple
                              }}
                              style={{fontSize: "14px"}}
                            >
                              Choose Product 
                            </MenuItem>
                            {products.map((data,key) => (
                              <MenuItem
                                style={{fontSize: "14px"}}
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelectedMultiple
                                }}
                                value = {data.id}
                                id = {key}
                                key = {data.id}
                              >
                                {data.name}
                              </MenuItem>
                            ))} 
                          </Select>
                        </FormControl>
                    </form>
                    </CardBody>
                    </Card>
                        <div className={classes.rootButton} style={{textAlign: 'center'}}>
                          <RegularButton  disabled={isFormSubmitting} 
                            variant="contained" 
                            style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', color: 'white', height: '50px', width: '190px', fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none', textAlign: 'center', marginBottom: '100px' }} 
                            onClick={this.addOrder}>
                              Add Order
                          </RegularButton>
                        </div>
                    </GridItem>
                    <Dialog
                      disableBackdropClick
                      open={showNoProductMessage}
                      onClose={() => {}}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogTitle id="alert-dialog-title">Need to create product</DialogTitle>
                        <DialogContent>
                          <DialogContentText id="alert-dialog-description">
                            Please create atleast one product to create an order.
                          </DialogContentText>
                        </DialogContent>
                      <DialogActions>
                        <RegularButton 
                          onClick={() => window.history.back()}
                          color="success">
                            Ok
                        </RegularButton>
                      </DialogActions>
                    </Dialog>
                </GridContainer>
            </div>
        )
    }
}
export default withStyles(useStyles, { withTheme: true })(Detailstable)